
export const createSlug = (string) => {
  return string.toLowerCase()
  .replace(/[^\w ]+/g,'')
  .replace(/ +/g,'-');
}